"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTextBaseline = exports.defaultTextAlign = exports.defaultStrokeStyle = exports.defaultPadding = exports.defaultMiterLimit = exports.defaultLineWidth = exports.defaultLineJoin = exports.defaultLineDashOffset = exports.defaultLineDash = exports.defaultLineCap = exports.defaultFont = exports.defaultFillStyle = exports.checkedFonts = void 0;
exports.drawImageOrLabel = drawImageOrLabel;
exports.getTextDimensions = getTextDimensions;
exports.labelCache = void 0;
exports.measureAndCacheTextWidth = measureAndCacheTextWidth;
exports.measureTextHeight = void 0;
exports.measureTextWidth = measureTextWidth;
exports.registerFont = void 0;
exports.rotateAtOffset = rotateAtOffset;
exports.textHeights = void 0;

var _Object = _interopRequireDefault(require("../Object.js"));

var _Target = _interopRequireDefault(require("../events/Target.js"));

var _has = require("../has.js");

var _obj = require("../obj.js");

var _dom = require("../dom.js");

var _css = require("../css.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @module ol/render/canvas
 */

/**
 * @typedef {Object} FillState
 * @property {import("../colorlike.js").ColorLike} fillStyle FillStyle.
 */

/**
 * @typedef Label
 * @property {number} width Width.
 * @property {number} height Height.
 * @property {Array<string|number>} contextInstructions ContextInstructions.
 */

/**
 * @typedef {Object} FillStrokeState
 * @property {import("../colorlike.js").ColorLike} [currentFillStyle] Current FillStyle.
 * @property {import("../colorlike.js").ColorLike} [currentStrokeStyle] Current StrokeStyle.
 * @property {CanvasLineCap} [currentLineCap] Current LineCap.
 * @property {Array<number>} currentLineDash Current LineDash.
 * @property {number} [currentLineDashOffset] Current LineDashOffset.
 * @property {CanvasLineJoin} [currentLineJoin] Current LineJoin.
 * @property {number} [currentLineWidth] Current LineWidth.
 * @property {number} [currentMiterLimit] Current MiterLimit.
 * @property {number} [lastStroke] Last stroke.
 * @property {import("../colorlike.js").ColorLike} [fillStyle] FillStyle.
 * @property {import("../colorlike.js").ColorLike} [strokeStyle] StrokeStyle.
 * @property {CanvasLineCap} [lineCap] LineCap.
 * @property {Array<number>} lineDash LineDash.
 * @property {number} [lineDashOffset] LineDashOffset.
 * @property {CanvasLineJoin} [lineJoin] LineJoin.
 * @property {number} [lineWidth] LineWidth.
 * @property {number} [miterLimit] MiterLimit.
 */

/**
 * @typedef {Object} StrokeState
 * @property {CanvasLineCap} lineCap LineCap.
 * @property {Array<number>} lineDash LineDash.
 * @property {number} lineDashOffset LineDashOffset.
 * @property {CanvasLineJoin} lineJoin LineJoin.
 * @property {number} lineWidth LineWidth.
 * @property {number} miterLimit MiterLimit.
 * @property {import("../colorlike.js").ColorLike} strokeStyle StrokeStyle.
 */

/**
 * @typedef {Object} TextState
 * @property {string} font Font.
 * @property {string} [textAlign] TextAlign.
 * @property {string} textBaseline TextBaseline.
 * @property {string} [placement] Placement.
 * @property {number} [maxAngle] MaxAngle.
 * @property {boolean} [overflow] Overflow.
 * @property {import("../style/Fill.js").default} [backgroundFill] BackgroundFill.
 * @property {import("../style/Stroke.js").default} [backgroundStroke] BackgroundStroke.
 * @property {import("../size.js").Size} [scale] Scale.
 * @property {Array<number>} [padding] Padding.
 */

/**
 * @typedef {Object} SerializableInstructions
 * @property {Array<*>} instructions The rendering instructions.
 * @property {Array<*>} hitDetectionInstructions The rendering hit detection instructions.
 * @property {Array<number>} coordinates The array of all coordinates.
 * @property {!Object<string, TextState>} [textStates] The text states (decluttering).
 * @property {!Object<string, FillState>} [fillStates] The fill states (decluttering).
 * @property {!Object<string, StrokeState>} [strokeStates] The stroke states (decluttering).
 */

/**
 * @typedef {Object<number, import("./canvas/Executor.js").ReplayImageOrLabelArgs>} DeclutterImageWithText
 */

/**
 * @const
 * @type {string}
 */
var defaultFont = '10px sans-serif';
/**
 * @const
 * @type {import("../colorlike.js").ColorLike}
 */

exports.defaultFont = defaultFont;
var defaultFillStyle = '#000';
/**
 * @const
 * @type {CanvasLineCap}
 */

exports.defaultFillStyle = defaultFillStyle;
var defaultLineCap = 'round';
/**
 * @const
 * @type {Array<number>}
 */

exports.defaultLineCap = defaultLineCap;
var defaultLineDash = [];
/**
 * @const
 * @type {number}
 */

exports.defaultLineDash = defaultLineDash;
var defaultLineDashOffset = 0;
/**
 * @const
 * @type {CanvasLineJoin}
 */

exports.defaultLineDashOffset = defaultLineDashOffset;
var defaultLineJoin = 'round';
/**
 * @const
 * @type {number}
 */

exports.defaultLineJoin = defaultLineJoin;
var defaultMiterLimit = 10;
/**
 * @const
 * @type {import("../colorlike.js").ColorLike}
 */

exports.defaultMiterLimit = defaultMiterLimit;
var defaultStrokeStyle = '#000';
/**
 * @const
 * @type {string}
 */

exports.defaultStrokeStyle = defaultStrokeStyle;
var defaultTextAlign = 'center';
/**
 * @const
 * @type {string}
 */

exports.defaultTextAlign = defaultTextAlign;
var defaultTextBaseline = 'middle';
/**
 * @const
 * @type {Array<number>}
 */

exports.defaultTextBaseline = defaultTextBaseline;
var defaultPadding = [0, 0, 0, 0];
/**
 * @const
 * @type {number}
 */

exports.defaultPadding = defaultPadding;
var defaultLineWidth = 1;
/**
 * @type {BaseObject}
 */

exports.defaultLineWidth = defaultLineWidth;
var checkedFonts = new _Object["default"]();
/**
 * The label cache for text rendering. To change the default cache size of 2048
 * entries, use {@link module:ol/structs/LRUCache~LRUCache#setSize cache.setSize()}.
 * Deprecated - there is no label cache any more.
 * @type {?}
 * @api
 * @deprecated
 */

exports.checkedFonts = checkedFonts;
var labelCache = new _Target["default"]();
exports.labelCache = labelCache;

labelCache.setSize = function () {
  console.warn('labelCache is deprecated.'); //eslint-disable-line
};
/**
 * @type {CanvasRenderingContext2D}
 */


var measureContext = null;
/**
 * @type {string}
 */

var measureFont;
/**
 * @type {!Object<string, number>}
 */

var textHeights = {};
/**
 * Clears the label cache when a font becomes available.
 * @param {string} fontSpec CSS font spec.
 */

exports.textHeights = textHeights;

var registerFont = function () {
  var retries = 100;
  var size = '32px ';
  var referenceFonts = ['monospace', 'serif'];
  var len = referenceFonts.length;
  var text = "wmytzilWMYTZIL@#/&?$%10\uF013";
  var interval, referenceWidth;
  /**
   * @param {string} fontStyle Css font-style
   * @param {string} fontWeight Css font-weight
   * @param {*} fontFamily Css font-family
   * @return {boolean} Font with style and weight is available
   */

  function isAvailable(fontStyle, fontWeight, fontFamily) {
    var available = true;

    for (var i = 0; i < len; ++i) {
      var referenceFont = referenceFonts[i];
      referenceWidth = measureTextWidth(fontStyle + ' ' + fontWeight + ' ' + size + referenceFont, text);

      if (fontFamily != referenceFont) {
        var width = measureTextWidth(fontStyle + ' ' + fontWeight + ' ' + size + fontFamily + ',' + referenceFont, text); // If width and referenceWidth are the same, then the fallback was used
        // instead of the font we wanted, so the font is not available.

        available = available && width != referenceWidth;
      }
    }

    if (available) {
      return true;
    }

    return false;
  }

  function check() {
    var done = true;
    var fonts = checkedFonts.getKeys();

    for (var i = 0, ii = fonts.length; i < ii; ++i) {
      var font = fonts[i];

      if (checkedFonts.get(font) < retries) {
        if (isAvailable.apply(this, font.split('\n'))) {
          (0, _obj.clear)(textHeights); // Make sure that loaded fonts are picked up by Safari

          measureContext = null;
          measureFont = undefined;
          checkedFonts.set(font, retries);
        } else {
          checkedFonts.set(font, checkedFonts.get(font) + 1, true);
          done = false;
        }
      }
    }

    if (done) {
      clearInterval(interval);
      interval = undefined;
    }
  }

  return function (fontSpec) {
    var font = (0, _css.getFontParameters)(fontSpec);

    if (!font) {
      return;
    }

    var families = font.families;

    for (var i = 0, ii = families.length; i < ii; ++i) {
      var family = families[i];
      var key = font.style + '\n' + font.weight + '\n' + family;

      if (checkedFonts.get(key) === undefined) {
        checkedFonts.set(key, retries, true);

        if (!isAvailable(font.style, font.weight, family)) {
          checkedFonts.set(key, 0, true);

          if (interval === undefined) {
            interval = setInterval(check, 32);
          }
        }
      }
    }
  };
}();
/**
 * @param {string} font Font to use for measuring.
 * @return {import("../size.js").Size} Measurement.
 */


exports.registerFont = registerFont;

var measureTextHeight = function () {
  /**
   * @type {HTMLDivElement}
   */
  var measureElement;
  return function (fontSpec) {
    var height = textHeights[fontSpec];

    if (height == undefined) {
      if (_has.WORKER_OFFSCREEN_CANVAS) {
        var font = (0, _css.getFontParameters)(fontSpec);
        var metrics = measureText(fontSpec, 'Žg');
        var lineHeight = isNaN(Number(font.lineHeight)) ? 1.2 : Number(font.lineHeight);
        height = lineHeight * (metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent);
      } else {
        if (!measureElement) {
          measureElement = document.createElement('div');
          measureElement.innerHTML = 'M';
          measureElement.style.minHeight = '0';
          measureElement.style.maxHeight = 'none';
          measureElement.style.height = 'auto';
          measureElement.style.padding = '0';
          measureElement.style.border = 'none';
          measureElement.style.position = 'absolute';
          measureElement.style.display = 'block';
          measureElement.style.left = '-99999px';
        }

        measureElement.style.font = fontSpec;
        document.body.appendChild(measureElement);
        height = measureElement.offsetHeight;
        document.body.removeChild(measureElement);
      }

      textHeights[fontSpec] = height;
    }

    return height;
  };
}();
/**
 * @param {string} font Font.
 * @param {string} text Text.
 * @return {TextMetrics} Text metrics.
 */


exports.measureTextHeight = measureTextHeight;

function measureText(font, text) {
  if (!measureContext) {
    measureContext = (0, _dom.createCanvasContext2D)(1, 1);
  }

  if (font != measureFont) {
    measureContext.font = font;
    measureFont = measureContext.font;
  }

  return measureContext.measureText(text);
}
/**
 * @param {string} font Font.
 * @param {string} text Text.
 * @return {number} Width.
 */


function measureTextWidth(font, text) {
  return measureText(font, text).width;
}
/**
 * Measure text width using a cache.
 * @param {string} font The font.
 * @param {string} text The text to measure.
 * @param {Object<string, number>} cache A lookup of cached widths by text.
 * @return {number} The text width.
 */


function measureAndCacheTextWidth(font, text, cache) {
  if (text in cache) {
    return cache[text];
  }

  var width = measureTextWidth(font, text);
  cache[text] = width;
  return width;
}
/**
 * @param {TextState} baseStyle Base style.
 * @param {Array<string>} chunks Text chunks to measure.
 * @return {{width: number, height: number, widths: Array<number>, heights: Array<number>, lineWidths: Array<number>}}} Text metrics.
 */


function getTextDimensions(baseStyle, chunks) {
  var widths = [];
  var heights = [];
  var lineWidths = [];
  var width = 0;
  var lineWidth = 0;
  var height = 0;
  var lineHeight = 0;

  for (var i = 0, ii = chunks.length; i <= ii; i += 2) {
    var text = chunks[i];

    if (text === '\n' || i === ii) {
      width = Math.max(width, lineWidth);
      lineWidths.push(lineWidth);
      lineWidth = 0;
      height += lineHeight;
      continue;
    }

    var font = chunks[i + 1] || baseStyle.font;
    var currentWidth = measureTextWidth(font, text);
    widths.push(currentWidth);
    lineWidth += currentWidth;
    var currentHeight = measureTextHeight(font);
    heights.push(currentHeight);
    lineHeight = Math.max(lineHeight, currentHeight);
  }

  return {
    width: width,
    height: height,
    widths: widths,
    heights: heights,
    lineWidths: lineWidths
  };
}
/**
 * @param {CanvasRenderingContext2D} context Context.
 * @param {number} rotation Rotation.
 * @param {number} offsetX X offset.
 * @param {number} offsetY Y offset.
 */


function rotateAtOffset(context, rotation, offsetX, offsetY) {
  if (rotation !== 0) {
    context.translate(offsetX, offsetY);
    context.rotate(rotation);
    context.translate(-offsetX, -offsetY);
  }
}
/**
 * @param {CanvasRenderingContext2D} context Context.
 * @param {import("../transform.js").Transform|null} transform Transform.
 * @param {number} opacity Opacity.
 * @param {Label|HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} labelOrImage Label.
 * @param {number} originX Origin X.
 * @param {number} originY Origin Y.
 * @param {number} w Width.
 * @param {number} h Height.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {import("../size.js").Size} scale Scale.
 */


function drawImageOrLabel(context, transform, opacity, labelOrImage, originX, originY, w, h, x, y, scale) {
  context.save();

  if (opacity !== 1) {
    context.globalAlpha *= opacity;
  }

  if (transform) {
    context.setTransform.apply(context, transform);
  }

  if (
  /** @type {*} */
  labelOrImage.contextInstructions) {
    // label
    context.translate(x, y);
    context.scale(scale[0], scale[1]);
    executeLabelInstructions(
    /** @type {Label} */
    labelOrImage, context);
  } else if (scale[0] < 0 || scale[1] < 0) {
    // flipped image
    context.translate(x, y);
    context.scale(scale[0], scale[1]);
    context.drawImage(
    /** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */
    labelOrImage, originX, originY, w, h, 0, 0, w, h);
  } else {
    // if image not flipped translate and scale can be avoided
    context.drawImage(
    /** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */
    labelOrImage, originX, originY, w, h, x, y, w * scale[0], h * scale[1]);
  }

  context.restore();
}
/**
 * @param {Label} label Label.
 * @param {CanvasRenderingContext2D} context Context.
 */


function executeLabelInstructions(label, context) {
  var contextInstructions = label.contextInstructions;

  for (var i = 0, ii = contextInstructions.length; i < ii; i += 2) {
    if (Array.isArray(contextInstructions[i + 1])) {
      context[contextInstructions[i]].apply(context, contextInstructions[i + 1]);
    } else {
      context[contextInstructions[i]] = contextInstructions[i + 1];
    }
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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